import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCaretUpDown = () => {
  return (
    <g>
      <path d="M13.254 9c.19.001.38.077.526.228a.8.8 0 0 1 .073 1.013l-.073.087-5.251 5.444-.084.075a.73.73 0 0 1-.901-.006l-.076-.069-5.248-5.44-.073-.087a.802.802 0 0 1 0-.926l.073-.087.084-.076a.73.73 0 0 1 .446-.152V9h10.504zM7.544.159a.73.73 0 0 1 .9-.006l.085.075 5.251 5.444.073.087a.8.8 0 0 1-.073 1.013.735.735 0 0 1-.526.228H2.75a.76.76 0 0 1-.446-.156l-.084-.076-.073-.087a.802.802 0 0 1 0-.926l.073-.087L7.468.228z" />
    </g>
  );
};

export default withIcon(IconCaretUpDown);
